// Component
import { FormElems, Accordion, BreadCrumb } from '../../components/';

// Helpers
import { getFilteredPgsData } from '../../utils/helperMethods';

// Constants
import { TEST_PREFIX } from '../../utils/constants/commonValues';

// Actions
import {
    savePgDetailsRequest,
    updatePgsRequest,
} from '../../containers/MerchantOnboard/redux/pgConfig/pgConfig.actions';
import ConfigForm from './ConfigForm';

// Validator
import validate from './validator';

// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const getValues = values => {
    const valuesResult = [];
    const valuesKeys = Object.keys(values);
    if (valuesKeys.length) {
        if (valuesKeys.some(value => value.indexOf(TEST_PREFIX) !== -1)) {
            valuesResult.push('test');
        }
        if (!valuesKeys.every(value => value.indexOf(TEST_PREFIX) !== -1)) {
            valuesResult.push('live');
        }
    }
    return valuesResult;
};

const ConfigDetails = ({
    data,
    actions,
    onBackClick,
    handleSubmit,
    onConfig,
    history,
    isEditMode,
    isViewMode,
    savedPgs,
    onModeSwitch,
    paymentModeOptions,
    paymentSubModeOptions,
}) => {
    const handleFormSubmit = values => {
        const request = getFilteredPgsData(values, data);
        actions.savePgDetailsRequest(request);
        actions.updatePgsRequest(data.uniqueId, savedPgs);
        onModeSwitch(getValues(values), data.uniqueId);
        onBackClick();
    };
    const handleLink = (event, link) => {
        event.preventDefault();
        if (link) {
            history.push(link);
        } else {
            onBackClick();
        }
    };
    return (
        <form
            className="config-list-form"
            onSubmit={handleSubmit(handleFormSubmit)}
            autoComplete="off"
        >
            <div className="pgconfig-tab card">
                <BreadCrumb
                    onBackClick={onBackClick}
                    onLinkClick={handleLink}
                    title={`${data.name} Configure`}
                    withBack
                    breadCrumbs={[
                        {
                            name: 'PG Configuration',
                            link: '',
                        },
                        { name: data.name, link: '' },
                    ]}
                />
                <div className="pgconfig-form">
                    <Accordion
                        customClass="custom-accordion"
                        isOpened={true}
                        isAlwaysExpendable
                        id="live-credentials-accordion"
                        upperComponent={
                            <h3 className="page-tile sm">Live Credentials</h3>
                        }
                        lowerComponent={
                            <ConfigForm
                                data={data}
                                onConfig={onConfig}
                                isViewMode={isViewMode}
                                paymentModeOptions={paymentModeOptions}
                                paymentSubModeOptions={paymentSubModeOptions}
                            />
                        }
                    />
                    {/* <Accordion
                        customClass="custom-accordion"
                        id="test-credentials-accordion"
                        upperComponent={
                            <h3 className="page-tile sm">Test Credentials</h3>
                        }
                        lowerComponent={
                            <ConfigForm
                                data={data}
                                onConfig={onConfig}
                                testPrefix={TEST_PREFIX}
                                isViewMode={isViewMode}
                            />
                        }
                    /> */}
                </div>
                <div className="form-section action leftSkewed testBtn">
                    <FormElems.Button
                        buttonType="primary"
                        text={isViewMode ? 'Back' : 'Submit'}
                    />
                </div>
            </div>
        </form>
    );
};

ConfigDetails.propTypes = {
    actions: PropTypes.object,
    data: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func,
    onBackClick: PropTypes.func,
    onConfig: PropTypes.func,
    onNext: PropTypes.func,
    onModeSwitch: PropTypes.func,
    history: PropTypes.object,
    isEditMode: PropTypes.bool,
    isViewMode: PropTypes.bool,
    savedPgs: PropTypes.object,
    paymentModeOptions: PropTypes.array,
    paymentSubModeOptions: PropTypes.array,
};

const mapStateToProps = ({ auth, form }) => ({
    auth,
    form,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            savePgDetailsRequest,
            updatePgsRequest,
        },
        dispatch
    ),
});

export default withRouter(
    compose(
        reduxForm({
            form: 'pgConfig-detail-form',
            validate,
        }),
        connect(mapStateToProps, mapDispatchToProps)
    )(ConfigDetails)
);
